import { IServiceResponseUsuario } from '../../../../app/core/models/services/response-app/response-app.interface';

import { IUserInfo } from '../../../../interface/user-info.interface';

export class ProfileModel {
  icon: string;
  companyName: string;
  userName: string;

  constructor(data: IServiceResponseUsuario) {
    this.parse(data);
  }

  /**
   * Parses profile information based on header model
   * @param data Data from API to assembly profile
   * @returns Parsed data on IUserInfo format
   */
  parse(data: IServiceResponseUsuario): IUserInfo {
    this.icon = 'usuario_outline';
    this.companyName = data.operador.trim().split(' ')[0];
    this.userName = data.empresas[0].razao_social;
    return this;
  }
}
